import * as i1 from '@chubb-auth/types';
import { AuthProvider, INITIAL_AUTH_STATE, StorageLocation, ADB2C_CONFIG, Adb2cUtilsModule } from '@chubb-auth/types';
import * as i0 from '@angular/core';
import { Injectable, Optional, Inject, NgModule } from '@angular/core';
import { BehaviorSubject, of, from } from 'rxjs';
import * as Msal from '@azure/msal-browser';
import { LogLevel, EventType } from '@azure/msal-browser';
import { isEmpty, isNil, cloneDeep } from 'lodash-es';
import { map, distinctUntilChanged, switchMap, skipWhile, timeoutWith } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

function loggerCallback$1(level, message) {
    console.log(message);
}
function noOpLogger$1() { }
function convertToState$1(response) {
    return isEmpty(response)
        ? {
            isLoggedIn: false,
        }
        : {
            isLoggedIn: response?.account !== null,
            userName: response?.account?.username,
            idToken: response?.idToken,
            accessToken: response?.accessToken,
            userClaims: response?.idTokenClaims,
        };
}
class ChubbAuthMsal2EventsService extends AuthProvider {
    _adb2cConfig;
    _utilsService;
    _authState$ = new BehaviorSubject(INITIAL_AUTH_STATE);
    _msalConfig;
    _msalAgent;
    account;
    constructor(_adb2cConfig, _utilsService) {
        super();
        this._adb2cConfig = _adb2cConfig;
        this._utilsService = _utilsService;
    }
    getState() {
        return this._authState$.value;
    }
    getTokenObject() {
        throw new Error('Not Supported');
    }
    initialize(adb2cConfig) {
        this._adb2cConfig = adb2cConfig || this._adb2cConfig;
        if (!this._utilsService.isValidAdb2cConfiguration(this._adb2cConfig)) {
            throw new Error(`Invalid ADB2C Configuration : ${!isNil(this._adb2cConfig) ? 'null' : JSON.stringify(this._adb2cConfig)}`);
        }
        else {
            this.updateMsalConfig();
        }
    }
    isLoggedIn() {
        return this._authState$.value.isLoggedIn;
    }
    login(extraQueryParameters) {
        this._msalAgent
            .loginRedirect({
            extraQueryParameters: extraQueryParameters,
            scopes: this._adb2cConfig.scopes,
        })
            .then();
    }
    get loginComplete$() {
        return this._authState$.pipe(map((state) => state.isLoggedIn));
    }
    logout(postLogoutRedirectUrl) {
        const msalConfig = cloneDeep(this._msalConfig);
        msalConfig.auth.postLogoutRedirectUri =
            postLogoutRedirectUrl || msalConfig.auth.postLogoutRedirectUri;
        const msalAgent = new Msal.PublicClientApplication(msalConfig);
        msalAgent
            .handleRedirectPromise()
            .then()
            .catch((error) => {
            this._authState$.next(INITIAL_AUTH_STATE);
            console.error(error);
        });
        msalAgent.logout().then();
    }
    getAccessToken() {
        return this.refreshState();
    }
    refreshState(timeoutInSeconds) {
        return this._authState$.pipe(distinctUntilChanged((previous, current) => previous.isLoggedIn === current.isLoggedIn), switchMap((state) => {
            if (!this.getAccount() && !state.isLoggedIn) {
                return of(state);
            }
            else {
                return from(this._msalAgent
                    .acquireTokenSilent({
                    account: this.getAccount(),
                    scopes: this._adb2cConfig.scopes,
                })
                    .catch((error) => {
                    if (error instanceof Msal.InteractionRequiredAuthError) {
                        // fallback to interaction when silent call fails
                        return this._msalAgent.acquireTokenRedirect({
                            account: this.getAccount(),
                            scopes: this._adb2cConfig.scopes,
                        });
                    }
                })).pipe(map((data) => convertToState$1(data)));
            }
        }));
    }
    getAccount() {
        if (this.account !== undefined) {
            return this.account;
        }
        const currentAccounts = this._msalAgent.getAllAccounts();
        if (currentAccounts?.length >= 1) {
            this.account = currentAccounts[0];
        }
        return this.account;
    }
    updateMsalConfig() {
        this._msalConfig = {
            auth: {
                clientId: this._adb2cConfig.clientId,
                authority: this._utilsService.getMsalAuthorityUrl(this._adb2cConfig),
                redirectUri: this._adb2cConfig.redirectUri,
                navigateToLoginRequestUrl: false,
                knownAuthorities: [
                    this._utilsService.getMsalAuthorityUrl(this._adb2cConfig),
                ],
                postLogoutRedirectUri: this._adb2cConfig.postLogoutRedirectUri,
            },
            cache: {
                cacheLocation: this._adb2cConfig.stateLocation || StorageLocation.Session,
            },
            system: {
                loggerOptions: {
                    loggerCallback: loggerCallback$1,
                    piiLoggingEnabled: false,
                    logLevel: LogLevel.Verbose,
                },
            },
        };
        this._msalAgent = new Msal.PublicClientApplication(this._msalConfig);
        this._msalAgent
            .handleRedirectPromise()
            .then()
            .catch((error) => console.error(error));
        this._msalAgent.addEventCallback(this._onMsalEvent.bind(this));
    }
    _onMsalEvent(message) {
        console.log('Event received ::', message);
        switch (message.eventType) {
            case EventType.ACQUIRE_TOKEN_SUCCESS:
            case EventType.LOGIN_SUCCESS:
                this._authState$.next(convertToState$1(message.payload));
                this.account = message.payload?.account;
                break;
        }
    }
    static ɵfac = function ChubbAuthMsal2EventsService_Factory(t) { return new (t || ChubbAuthMsal2EventsService)(i0.ɵɵinject(ADB2C_CONFIG, 8), i0.ɵɵinject(i1.Adb2cUtilsService)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ChubbAuthMsal2EventsService, factory: ChubbAuthMsal2EventsService.ɵfac });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChubbAuthMsal2EventsService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [ADB2C_CONFIG]
            }] }, { type: i1.Adb2cUtilsService }]; }, null); })();

function loggerCallback(level, message) {
    console.log(message);
}
function noOpLogger() { }
function convertToState(response) {
    return isEmpty(response)
        ? {
            isLoggedIn: false,
        }
        : {
            isLoggedIn: true,
            userName: null,
            idToken: response?.idToken,
            accessToken: response?.accessToken,
            userClaims: response?.idTokenClaims,
        };
}
class ChubbAuthMsal2PkceService extends AuthProvider {
    _adb2cConfig;
    _utilsService;
    constructor(_adb2cConfig, _utilsService) {
        super();
        this._adb2cConfig = _adb2cConfig;
        this._utilsService = _utilsService;
        this._authState = INITIAL_AUTH_STATE;
        this._loginComplete = new BehaviorSubject(false);
    }
    _msalConfig;
    _msalAgent;
    _authState;
    _authResult;
    _loginComplete;
    account;
    get loginComplete$() {
        return this._loginComplete.asObservable();
    }
    initialize(adb2cConfig) {
        this._adb2cConfig = adb2cConfig || this._adb2cConfig;
        if (!this._utilsService.isValidAdb2cConfiguration(this._adb2cConfig)) {
            throw new Error(`Invalid ADB2C Configuration : ${!isNil(this._adb2cConfig) ? 'null' : JSON.stringify(this._adb2cConfig)}`);
        }
        else {
            this.updateMsalConfig();
        }
    }
    updateMsalConfig() {
        this._msalConfig = {
            auth: {
                clientId: this._adb2cConfig.clientId,
                authority: this._utilsService.getMsalAuthorityUrl(this._adb2cConfig),
                redirectUri: this._adb2cConfig.redirectUri,
                navigateToLoginRequestUrl: false,
                knownAuthorities: [
                    this._utilsService.getMsalAuthorityUrl(this._adb2cConfig),
                ],
                postLogoutRedirectUri: this._adb2cConfig.postLogoutRedirectUri,
            },
            cache: {
                cacheLocation: this._adb2cConfig.stateLocation || StorageLocation.Session,
            },
            system: {
                loggerOptions: {
                    loggerCallback,
                    piiLoggingEnabled: false,
                    logLevel: LogLevel.Verbose
                },
            },
        };
        this._msalAgent = new Msal.PublicClientApplication(this._msalConfig);
        this._msalAgent
            .handleRedirectPromise()
            .then(this._onLoginSuccessful.bind(this))
            .catch((error) => {
            this._authState = INITIAL_AUTH_STATE;
            console.error(error);
        });
    }
    _onLoginSuccessful(response) {
        this._authState = convertToState(response);
        this.account = response?.account ?? this.getAccount();
    }
    isLoggedIn() {
        return this._authState.isLoggedIn;
    }
    getState() {
        return this._authState;
    }
    login(extraQueryParameters) {
        this._msalAgent
            .loginRedirect({
            extraQueryParameters: extraQueryParameters,
            scopes: this._adb2cConfig.scopes,
        })
            .then(() => this._loginComplete.next(true));
    }
    logout(postLogoutRedirectUrl) {
        const msalConfig = cloneDeep(this._msalConfig);
        msalConfig.auth.postLogoutRedirectUri =
            postLogoutRedirectUrl || msalConfig.auth.postLogoutRedirectUri;
        const msalAgent = new Msal.PublicClientApplication(msalConfig);
        msalAgent
            .handleRedirectPromise()
            .then(this._onLoginSuccessful.bind(this))
            .catch((error) => {
            this._authState = INITIAL_AUTH_STATE;
            console.error(error);
        });
        msalAgent.logout().then();
    }
    getAccount() {
        if (this.account !== undefined) {
            debugger;
            return this.account;
        }
        debugger;
        const currentAccounts = this._msalAgent.getAllAccounts();
        if (currentAccounts?.length >= 1) {
            this.account = currentAccounts[0];
        }
        return this.account;
    }
    refreshState(timeoutInSeconds) {
        return this._loginComplete.pipe(skipWhile((value) => !value), timeoutWith((timeoutInSeconds || 2) * 1000, of(this._authState)), // fix: optimized the performance by updating timeout = 0
        switchMap(() => {
            if (isEmpty(this.getAccount())) {
                console.log('Account Object is NULL' + ' _msalAgent' + this._msalAgent + ' this._msalAgent.getAllAccounts()' + this._msalAgent.getAllAccounts());
                console.log('this._authState' + this._authState);
                return;
            }
            else {
                const acc = this.getAccount();
                return from(this._msalAgent.acquireTokenSilent({
                    account: acc,
                    scopes: this._adb2cConfig.scopes,
                })).pipe(map((authResult) => {
                    this._authState.accessToken = authResult?.accessToken;
                    this._authState.idToken = authResult?.idToken;
                    this._authState.userClaims = authResult?.idTokenClaims;
                    this._authState.isLoggedIn = !isNil(authResult?.accessToken);
                    this._authState.userName = authResult.account?.username;
                    return this._authState;
                }));
            }
        }));
    }
    getAccessToken() {
        return this.refreshState().pipe(switchMap((state) => {
            const jwtHelper = new JwtHelperService();
            const isExpired = jwtHelper.isTokenExpired(state.accessToken);
            console.log('Chubb-Auth library - MSAL2 PKCE- isExpired', isExpired);
            if (isExpired && state.accessToken) {
                return this.getTokenObject().pipe(map((authResult) => {
                    this._authState.accessToken = authResult?.accessToken;
                    this._authState.idToken = authResult?.idToken;
                    this._authState.userClaims = authResult?.idTokenClaims;
                    this._authState.isLoggedIn = !isNil(authResult?.accessToken);
                    this._authState.userName = authResult.account?.username;
                    return this._authState;
                }));
            }
            return of(this._authState);
        }));
    }
    getTokenObject() {
        return from(this._msalAgent
            .acquireTokenSilent({
            account: this.getAccount(),
            scopes: this._adb2cConfig.scopes,
            forceRefresh: true,
        })
            .catch((error) => {
            if (error instanceof Msal.InteractionRequiredAuthError) {
                // fallback to interaction when silent call fails
                return this._msalAgent.acquireTokenRedirect({
                    account: this.getAccount(),
                    scopes: this._adb2cConfig.scopes,
                });
            }
        })).pipe(map((data) => {
            this._authResult = data;
            return this._authResult;
        }));
    }
    static ɵfac = function ChubbAuthMsal2PkceService_Factory(t) { return new (t || ChubbAuthMsal2PkceService)(i0.ɵɵinject(ADB2C_CONFIG, 8), i0.ɵɵinject(i1.Adb2cUtilsService)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ChubbAuthMsal2PkceService, factory: ChubbAuthMsal2PkceService.ɵfac });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChubbAuthMsal2PkceService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [ADB2C_CONFIG]
            }] }, { type: i1.Adb2cUtilsService }]; }, null); })();

class ChubbAuthMsal2PkceModule {
    constructor(factory, provider, eventBasedProvider) {
        factory.registerProvider('MSAL2', provider);
        factory.registerProvider('MSAL2WithEvents', eventBasedProvider);
    }
    static ɵfac = function ChubbAuthMsal2PkceModule_Factory(t) { return new (t || ChubbAuthMsal2PkceModule)(i0.ɵɵinject(i1.AuthProviderFactory), i0.ɵɵinject(ChubbAuthMsal2PkceService), i0.ɵɵinject(ChubbAuthMsal2EventsService)); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ChubbAuthMsal2PkceModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [ChubbAuthMsal2PkceService, ChubbAuthMsal2EventsService], imports: [CommonModule, HttpClientModule, Adb2cUtilsModule] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChubbAuthMsal2PkceModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [CommonModule, HttpClientModule, Adb2cUtilsModule],
                providers: [ChubbAuthMsal2PkceService, ChubbAuthMsal2EventsService],
            }]
    }], function () { return [{ type: i1.AuthProviderFactory }, { type: ChubbAuthMsal2PkceService }, { type: ChubbAuthMsal2EventsService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ChubbAuthMsal2PkceModule, { imports: [CommonModule, HttpClientModule, Adb2cUtilsModule] }); })();

/*
 * Public API Surface of chubb-auth-msal2-pkce
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChubbAuthMsal2EventsService, ChubbAuthMsal2PkceModule, ChubbAuthMsal2PkceService };
